/**
 *
 * Builds the literals an OData query is assembled from
 *
 */

export default class Odata {
    /**
     * Wraps a value as an OData string literal, quotes included. A quote inside the value is doubled,
     * which is how OData spells a literal one - without that, a value carrying quotes of its own ends the
     * literal early and leaves the rest of the expression as syntax the parser rejects.
     */
    static stringLiteral(value: string): string {
        return `'${String(value ?? "").replace(/'/g, "''")}'`;
    }

    /**
     * The same literal for a query string, where a plus, an ampersand or a hash in the value would
     * otherwise not arrive as the character it was. The doubled quotes survive the encoding untouched,
     * as a quote is not among the characters encodeURIComponent escapes.
     */
    static encodedStringLiteral(value: string): string {
        return encodeURIComponent(Odata.stringLiteral(value));
    }
}
